import React, { useState, useEffect } from 'react';
import { GoogleMap, LoadScript, Marker, OverlayView } from '@react-google-maps/api';
// Map container style
const containerStyle = {
    width: '100%',
    height: '600px',
};

// Initial center of the map
const center = {
    lat: 10.7949646, // Default latitude 
    lng: 78.68567329999999, // Default longitude
};
// Custom vehicle icon
const image1 = require('../../assets/img/truckgreen.png')
const image2 = require('../../assets/img/truckYellow.png')
const image3 = require('../../assets/img/truckRed.png')
const image4 = require('../../assets/img/truckgray.png')

const icons = {
    active: {
        url: image1,
        scaledSize: { width: 50, height: 50 },
    },
    idle: {
        url: image4,
        scaledSize: { width: 50, height: 50 },
    },
    disabled: {
        url: image3,
        scaledSize: { width: 50, height: 50 },
    },
};

// const statusColors = {
//     active: "bg-green-500",   // Green for active
//     idle: "bg-gray-500",    // Yellow for idle
//     disabled: "bg-red-500",   // Red for disabled
// };

const statusColors = {
    active: "green",   // Green for active
    idle: "gray",    // Yellow for idle
    disabled: "red",   // Red for disabled
};

const locationIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="white" stroke-width="2" viewBox="0 0 24 24"><path d="M12 2C7.03 2 4 5.03 4 8c0 3.47 3.14 7.03 6.5 9.33L12 21l1.5-3.67C16.86 15.03 20 11.47 20 8c0-2.97-3.03-6-8-6zM12 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/></svg>`;

const LiveTrackingMap = () => {
    const [vehicles, setVehicles] = useState([
        { id: 1, lat: 10.7949646, lng: 78.68567329999999, title: 'ram', status: 'active' },
        { id: 2, lat: 10.7984746, lng: 78.68034469999999, title: 'kumar', status: 'idle' },
        { id: 2, lat: 10.7984746, lng: 78.68434569999999, title: 'vinoth', status: 'disabled' },
    ]);

    // Simulating live updates
    useEffect(() => {
        const interval = setInterval(() => {
            setVehicles((prev) =>
                prev.map((vehicle) => ({
                    ...vehicle,
                    lat: vehicle.lat + (Math.random() - 0.5) * 0.001, // Random small change
                    lng: vehicle.lng + (Math.random() - 0.5) * 0.001,
                    status: Math.random() > 0.7 ? 'disabled' : Math.random() > 0.4 ? 'idle' : 'active',
                }))
            );
        }, 5000); // Update every 5 seconds
        return () => clearInterval(interval);
    }, []);

    return (
        <div className='flex flex-row justify-center items-center w-full'>
            <div className='m-10 w-full'>
                <h1 className='text-2xl p-3'>Live tracking</h1>
                <LoadScript googleMapsApiKey="AIzaSyDOCJ7V-QaS9nnf7zZ1B7ZEgrkI-YcxWA0">
                    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={14}>
                        {vehicles.map((vehicle) => (
                            <React.Fragment key={vehicle.id}>
                                <Marker
                                    position={{ lat: vehicle.lat, lng: vehicle.lng }}
                                    icon={icons[vehicle.status]}
                                    title={vehicle.title}
                                />
                                <OverlayView
                                    position={{ lat: vehicle.lat, lng: vehicle.lng }}
                                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                                >
                                    <div className="flex items-center text-sm font-bold h-0">
                                        <div className="flex items-center justify-center w-4 h-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill={`${statusColors[vehicle.status]}`} stroke="none" viewBox="0 0 24 24">
                                                <circle cx="12" cy="12" r="10" />
                                            </svg>
                                        </div>
                                        <span className="ml-1 text-base">{vehicle.title}</span>
                                    </div>
                                </OverlayView>
                            </React.Fragment>
                        ))}
                    </GoogleMap>
                </LoadScript>
            </div>
        </div>

    );
};
export default LiveTrackingMap;